import { ReactNode } from 'react';

import { Card } from 'antd';

interface IntegrationCardProps {
  title: string;
  /** Icono que identifica el tipo de sección. */
  icon: ReactNode;
  /** Resumen de cómo quedó configurada, alineado a la derecha del header. */
  summary?: ReactNode;
  children: ReactNode;
}

/**
 * Agrupa una sección del formulario en una card con encabezado propio. La usan
 * los modales de compañía y de rol para separar qué configura cada bloque.
 */
function IntegrationCard({
  title,
  icon,
  summary,
  children,
}: IntegrationCardProps) {
  return (
    <Card
      size="small"
      style={{ marginBottom: 20 }}
      styles={{ header: { backgroundColor: '#fafafa' } }}
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span
            style={{
              display: 'inline-flex',
              color: 'rgba(0, 0, 0, 0.45)',
              flex: '0 0 auto',
            }}
          >
            {icon}
          </span>
          {title}
        </span>
      }
      extra={summary}
    >
      {children}
    </Card>
  );
}

export default IntegrationCard;
